import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCatalogById } from '../../app/helpers/getCatalogById';
import { getObjectById } from '../../app/helpers/getObjectById';
import { getFieldInfo } from '../../app/helpers/getFieldInfo';
import { useTranslation } from 'react-i18next';
import "./tableComparison.css";

const TableHorizontalFullInnovation = ({ data }) => {
  const { t } = useTranslation();

  // 1. Selectores de Redux específicos para Innovation
  const { listFieldsInnovation } = useSelector((state) => state.moduleConfig);
  const { listFullCatalogs } = useSelector((state) => state.catalog);
  const { listFullCatalogCiius } = useSelector((state) => state.catalogCiiu);
  const { listContinents, listFullRegions, listFullCountries } = useSelector((state) => state.locationCountry);

  // 2. Filtros y preparación de datos memoizados
  const comparedData = useMemo(() => data.filter(dta => dta.isCompared || dta.isSelected), [data]);
  const comparableFields = useMemo(() => listFieldsInnovation.filter(f => f.is_comparable), [listFieldsInnovation]);

  // 3. Helper de resolución (Eliminado el if-else hell)
  const resolveCellValue = (fieldKey, dataObject) => {
    const fieldFound = getFieldInfo(fieldKey, listFieldsInnovation);
    if (!fieldFound || !fieldFound.is_comparable) return null;

    const val = dataObject[fieldKey];
    const condition = fieldFound.comparable_relation_condition;

    const resolvers = {
      "Fields": () => val,
      "Catalogs": () => getCatalogById(val, listFullCatalogs)?.description,
      "CatalogCiius": () => getObjectById(val, listFullCatalogCiius)?.name,
      "CatalogSections": () => getObjectById(val, listFullCatalogCiius)?.name,
      "CatalogPhases": () => getObjectById(val, listFullCountries)?.name,
      "CatalogCountries": () => getObjectById(val, listFullCountries)?.name,
      "CatalogRegions": () => getObjectById(val, listFullRegions)?.name,
      "CatalogContinents": () => getObjectById(val, listContinents)?.name,
      "Year": () => val ? new Date(val).getFullYear() : '',
    };

    return resolvers[condition] ? resolvers[condition]() : null;
  };

  return (
    <div className='table-horizontal-scroll-full'>
      <table className='table table-comparison'>
        <thead>
          <tr>
            {/* Esquina superior izquierda fija */}
            <th className="sticky-corner" style={{ left: 0, zIndex: 11 }}>
              {t('general.table.header.common.fields')}
            </th> 
            {comparedData.map((dta) => (
              <th key={`h-${dta.id}`} scope="col" className="text-center">
                <div className="text-primary">ID: {dta.id}</div>
                <small className="text-muted d-block">{dta.code || 'N/A'}</small>
              </th>
            ))}
          </tr>
        </thead>
        
        <tbody>
          {comparableFields.map((fieldItem) => (
            <tr key={`row-${fieldItem.field}`}>
              {/* Etiqueta del campo fija lateralmente */}
              <th scope="row" className="sticky-column">
                {t(`${fieldItem.module_text}.synthetic.${fieldItem.field}`)}
              </th>
              {comparedData.map((dta) => (
                <td key={`cell-${fieldItem.field}-${dta.id}`} className="align-middle">
                  {resolveCellValue(fieldItem.field, dta) || (
                    <span className="text-muted small">---</span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {comparedData.length === 0 && (
        <div className="text-center py-5 border-top">
          <p className="text-muted mb-0">{t("general.no-data-selected")}</p>
        </div>
      )}
    </div>
  );
};

export default TableHorizontalFullInnovation;
